import React from 'react'

import {
  NavLink,
  useHistory,
} from 'react-router-dom'

import {
  findIndex,
  sortBy,
} from 'lodash'

import { SiteContext } from 'context/site-context'

import { isWebpSupported } from 'helpers'

import cn from 'classnames'

import './index.scss'

const Cities = () => {
  const [ site, setSite] = React.useContext(SiteContext)

  const history = useHistory()

  const handleCityClick = (e, location) => {
    localStorage.setItem('geoInfo', JSON.stringify({
      location: location,
      city: location.split(', ')[0],
      region_code: location.split(', ')[1],
    }))

    setSite({
      ...site,
      location: location,
    })
  }

  // Need to reduce to an array of states with and array of Cities
  const getCities = () => {
    const cities = site.popular_cities ? sortBy(site.popular_cities, ['state']).reduce( (ordered, city) => {
      if(findIndex(ordered, { label: city.state }) === -1){
        ordered.push({
          label: city.state,
          isState: true,
        })
      }
      ordered.push({
        label: city.label.split(',')[0],
        key: city.label,
        state: city.state,
      })
      return ordered
    }, [] ) : []

    return cities
  }

  return (
    <div className="cities-container">
      <ul>
        {getCities().length > 0 && getCities().map( city => {
          return <li key={city.isState ? city.label : city.key} className={cn( {state: city.isState} )}>
            {city.isState ? city.label : <NavLink to={`/${city.key.split(', ')[1].toLowerCase()}/${city.key.split(', ')[0].toLowerCase()}${!!new URLSearchParams(window.location.search).get('useSampleData') ? '&useSampleData=true' : ''}`} onClick={ e => handleCityClick(e, city.key)}>{city.label}</NavLink>}
          </li>}
        )}
      </ul>
    </div>
  )
}

export default Cities
